module.exports = __webpack_public_path__ + "img/babyMother.5da8b752.png";